import { css } from 'styled-components';
import { TextStyles } from './modules/text';

export const getTextStyles = (textTheme: TextStyles) => css`
  font-family: ${textTheme.fontFamily};
  font-style: ${textTheme.fontStyle};
  font-weight: ${textTheme.fontWeight};
  font-size: ${textTheme.fontSize};
  line-height: ${textTheme.lineHeight};
  color: ${textTheme.color};
  text-decoration: ${textTheme.textDecoration};
  letter-spacing: ${textTheme.letterSpacing};
`;
